import {call, put, takeLatest} from "redux-saga/effects";
import _ from "lodash";

import {API} from "../../../api/api";
import {ToasterService} from "../../../services/toaster/toaster.service";
import {ConfigurationsActionTypes} from "../actions/actionTypes";
import {configurationsAPI} from "../api/api";
import {configurationsStoreSelectors} from "../store/store";
import {
    getRTPProfileValue,
    getSavedRTPProfile
} from "../components/Utils/rtp-profiles";

const hasSubsidiary = (profile, subsidiary) => {
    const subsidiaries = Array.isArray(profile.subsidiary)
        ? profile.subsidiary
        : [profile.subsidiary];

    return subsidiaries.some(profileSubsidiary => {
        const profileSubsidiaryId =
            profileSubsidiary && typeof profileSubsidiary === "object"
                ? profileSubsidiary.id
                : profileSubsidiary;

        return `${profileSubsidiaryId}` === `${subsidiary}`;
    });
};

function* getRTPProfiles(action) {
    try {
        const {subsidiary} = action.payload;
        const [profilesResponse, gameInstancesResponse] = yield call(() =>
            Promise.all([
                configurationsAPI.getRTPProfiles(),
                configurationsAPI.getGameInstances({subsidiary})
            ])
        );

        const profiles = profilesResponse.data.results || [];
        const defaultProfile = _.find(
            profiles,
            profile => hasSubsidiary(profile, subsidiary)
        );
        const configuredSettings =
            configurationsStoreSelectors.editingConfiguration().settings
                .settings.game_rtp_profiles;
        const gameConfigurations: any[] =
            gameInstancesResponse.data.results;
        const gameInstancesByGame = _.groupBy(gameConfigurations, "game.id");
        const games = Object.keys(gameInstancesByGame).map(gameId => {
            const gameInstances = gameInstancesByGame[gameId];
            const gameConfiguration = gameInstances[0];

            return {
                description: gameConfiguration.label,
                game: gameConfiguration.game,
                gameInstanceIdentifiers: gameInstances.map(
                    gameInstance => gameInstance.identifier
                ),
                identifier: gameConfiguration.game.id
            };
        });

        const settings = _.orderBy(
            games.map(game => {
                const configuredProfile = getSavedRTPProfile(
                    configuredSettings,
                    game.identifier,
                    profiles
                );
                const profile =
                    configuredProfile !== null
                        ? configuredProfile
                        : defaultProfile
                        ? getRTPProfileValue(defaultProfile)
                        : null;

                return {
                    ...game,
                    profile,
                    originalProfile: profile
                };
            }),
            ["description"],
            ["asc"]
        );

        yield put({
            type: ConfigurationsActionTypes.GET_RTP_PROFILES_SUCCESS,
            payload: {
                defaultProfile,
                profiles,
                settings
            }
        });

        yield put({
            type: ConfigurationsActionTypes.REORDER_RTP_PROFILES_SUCCESS,
            payload: {key: "description", direction: "asc"}
        });
    } catch (e) {
        API.handleError(e.response, "Error getting RTP Profiles");

        yield put({
            type: ConfigurationsActionTypes.GET_RTP_PROFILES_FAIL,
            payload: e
        });
    }
}

function* reorderRTPProfiles(action) {
    const {settings, order} = action.payload;

    try {
        yield put({
            type: ConfigurationsActionTypes.GET_RTP_PROFILES_SUCCESS,
            payload: {
                defaultProfile:
                    configurationsStoreSelectors.rtpDefaultProfile(),
                profiles: configurationsStoreSelectors.rtpProfiles(),
                settings: _.orderBy(settings, order.key, order.direction)
            }
        });
        yield put({
            type: ConfigurationsActionTypes.REORDER_RTP_PROFILES_SUCCESS,
            payload: order
        });
    } catch (e) {
        ToasterService.errorToast("Unable to reorder RTP Profiles.");
    }
}

export function* getRTPProfilesWatcher() {
    yield takeLatest(
        ConfigurationsActionTypes.GET_RTP_PROFILES,
        getRTPProfiles
    );
}

export function* reorderRTPProfilesWatcher() {
    yield takeLatest(
        ConfigurationsActionTypes.REORDER_RTP_PROFILES,
        reorderRTPProfiles
    );
}
